import { MutationTree } from 'vuex'
import StockState from './StockState'
import * as types from './mutation-types'

const mutations: MutationTree <StockState> = {
  [types.STOCK_ADD_TO_CACHED_MULTIPLE] (state, payload) {
    if (payload.stockMoveTask) {
      payload.stockMoveTask.stockMoveTasks.forEach((stock: any) => {
        state.cached[stock.workEffortId] = stock;
      });
    }
  },
  [types.STOCK_DETAILS_UPDATED](state, payload) {
    state.stockDetails = payload;
  },
  [types.STOCK_LIST_UPDATED](state, payload) {
    if(payload.type === "cold") {
      state.coldTasks = {
        list: payload.tasks,
        total: payload.total
      };
    } else {
      state.tasks = {
        list: payload.tasks,
        total: payload.total
      };
    }
  },
}
export default mutations;